import Vue from 'vue';
import SweetMobileUI from '@sweet/mobile-ui';
// import '@sweet/ui-reboot/dist/index.css';
import '@sweet/mobile-ui/dist/index.css';
import '@sweet/ui-utils/dist/index.css';

Vue.use(SweetMobileUI);

export default SweetMobileUI;
